import React , {useContext, useEffect,useState} from 'react'
import { Link , useLocation,useParams} from 'react-router-dom';
import '../../styles/devotionalContentsPage.css'
import DevotionalBreadCrumb from './devotionalBreadCrumb';
import { Helmet } from 'react-helmet-async';
import { DeviceContext } from '.';
import PageAds from '../common/pageAds';



const DevotionalContentsPage = ({ data: ssrData }) => {
                            const ssrCatData = ssrData?.[0]?.contentsPageData?.eachCategoryData || null;
                            const ssrDataError = ssrData?.[0]?.contentsPageDataError || null;
                     const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                            const { category } = useParams();
                             
                            const cat_id = category.substring(
                              category.lastIndexOf('-') + 1,
                              category.lastIndexOf('.html')
                            );
                            const breadCrumb = category.substring(
                              category.lastIndexOf('/') + 1,
                              category.lastIndexOf('-')
                            );

                         
                            const ssrCatId = ssrData?.cat_id; 

                            const [data, setData] = useState(ssrCatData);
                            const [error, setError] = useState(null);
                            const [loading, setLoading] = useState(false);


                    function isTelugu(text) {

                       const teluguRegex = /[\u0C00-\u0C7F]/;
                       return teluguRegex.test(text);
                       
                     }  

                  useEffect(() => {
                    
                    if (ssrCatData && ssrCatId === cat_id) {
                      setError(null);
                      setLoading(false);
                      return;
                    }

                 
                    setLoading(true);
                    setData(null);

                    const getData = async () => {
                      try {
                        const response = await fetch(
                          `https://www.teluguone.com/devotional_api/devotionalCatsPageJson?cat_id=${cat_id}`
                        );
                        if (!response.ok) throw new Error('Network response was not ok');
                        const json = await response.json();

                        setData(json.devotional_categories);
                        setError(null);
                      } catch (err) {
                        setData(null);
                        setError(err.message);
                        console.error("Fetch error:", err.message);
                      } finally {
                        setLoading(false);
                      }
                    };

                    getData();
                  }, [category]);
                              



    
    
                if (loading )  {

                return (  
                    <div className='devotional-contents-page' >
                      <div className='devotional-contents-grid'>
                        {Array(10).fill("o").map((_,index) =>
                          <div key={index} className="devotional-contents-item">
                            <figure className="devotional-contents-figure">
                              <Link
                                to=''
                                className="first-anchor"
                              >
                                <img
 
                                  src="/devotional/assets/images/error_img.webp"
                                  alt="Devotional content image"
                                />
                              </Link>

                              <figcaption>
                                <Link                         
                                  to=""
                                >
                                  loading...
                                </Link>
                              </figcaption>
                            </figure>
                          </div>
                        ) }
                
                   </div>
                    </div>            
                    )
                
                }


                if (error) {

                return (
                    <div className='devotional-contents-page' >
                      <div className='container-fluid g-0'>
                        <div className='row g-0'>    
                            <div className="col-12">
                              <div className="json-loading-error-div">
                                <img   src="/devotional/assets/images/json_error.png" alt="json_error" />
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                )
                }





                  return (


                    <div className='devotional-contents-page' >
              
                          <Helmet > <title>Hindu Gods | Telugu Devotional | TeluguOne Hindu Gods | Gods | Festivals | Hanuman Chalisa | Pravachanalu | Devotional Songs | Ramayanam | Bhaga</title></Helmet>
                  
                    <DevotionalBreadCrumb  breadCrumb={breadCrumb.charAt(0).toUpperCase()+breadCrumb.slice(1)} type={"contents"} />
                     <div className="devotional-contents-grid">
                           {Array.isArray(data) && data.map((item,index) => (
                          <div key={index} className="devotional-contents-item">
                            <figure className="devotional-contents-figure">
                              <Link
                                to={item.category_url
                                  ? item.category_url.substring(item.category_url.indexOf('/devotional') + 11)
                                  : "/"}
                                className="first-anchor"
                              >
                                <img
                                  loading={index === 0 ? "eager" : "lazy"}
                                  fetchpriority={index === 0 ? "high" : 'auto'}
                                  src={item.image_url || "/devotional/assets/images/error_img.webp"}
                                  alt={item.category_name || "Devotional content image"}
                                />
                              </Link>

                              <figcaption>
                                <Link
                                  
                               
                                  to={
                                    item.category_url
                                      ? item.category_url.substring(
                                          item.category_url.indexOf("/devotional") + 11
                                        )
                                      : "/"
                                  }
                                >
                                  {item.category_name || "Title"}
                                </Link>
                              </figcaption>
                            </figure>
                          </div>
                            ))}
                      </div>
                       <PageAds mobile={mobile} containerRef={containerRef} />
                </div>
                    
                  )
                }

                        export default DevotionalContentsPage;



